import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

function getVisitorId() {
  let id = localStorage.getItem("edil_vid");
  if (!id) {
    id = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("edil_vid", id);
  }
  return id;
}

function getDevice() {
  const ua = navigator.userAgent || "";
  if (/iPad|Tablet|PlayBook|Silk/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua))) return "tablet";
  if (/Mobi|iPhone|Android.*Mobile|Windows Phone|iPod/i.test(ua)) return "mobile";
  return "desktop";
}

function currentScrollPct() {
  const doc = document.documentElement;
  const total = doc.scrollHeight - doc.clientHeight;
  if (total <= 0) return 100;
  return Math.min(100, Math.round(((window.scrollY || doc.scrollTop) + doc.clientHeight) / doc.scrollHeight * 100));
}

export default function PageTracker() {
  const location = useLocation();
  const session = useRef({ path: null, start: 0, maxScroll: 0 });

  const flush = () => {
    const s = session.current;
    if (!s.path) return;
    const duration = (Date.now() - s.start) / 1000;
    const payload = { path: s.path, visitor_id: getVisitorId(), duration, scroll: s.maxScroll };
    try {
      const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
      if (!navigator.sendBeacon || !navigator.sendBeacon(`${API_BASE}/track/engagement`, blob)) {
        api.post("/track/engagement", payload).catch(() => {});
      }
    } catch (e) {
      api.post("/track/engagement", payload).catch(() => {});
    }
  };

  useEffect(() => {
    const onScroll = () => {
      const p = currentScrollPct();
      if (p > session.current.maxScroll) session.current.maxScroll = p;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    const onHide = () => flush();
    window.addEventListener("pagehide", onHide);
    document.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") flush(); });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("pagehide", onHide);
    };
  }, []);

  useEffect(() => {
    const path = location.pathname;
    // flush previous page engagement before starting the new one
    flush();
    session.current = { path: path.startsWith("/admin") || path.startsWith("/login") ? null : path, start: Date.now(), maxScroll: currentScrollPct() };

    if (path.startsWith("/admin") || path.startsWith("/login")) return;

    let referrer = "";
    try {
      if (document.referrer) {
        const r = new URL(document.referrer);
        if (r.host !== window.location.host) referrer = document.referrer;
      }
    } catch (e) { /* ignore */ }

    api.post("/track", { path, referrer, visitor_id: getVisitorId(), device: getDevice() }).catch(() => {});
  }, [location.pathname]);

  return null;
}
